module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-6-d32ab2d17efcfa382e49dc956ff62417.jpg";